import { Col, Row, Typography } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import StyledAppButton from "../../../_shared/components/AppButton"
import AppInput from "../../../_shared/components/FormItems/AppInput"

const { Title, Paragraph } = Typography
// ----------------------------------------------------------------------------

function _ForgotPassword(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, isRequestSent, onSubmit, Error } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [email, setEmail] = useState("")

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleSubmit(e) {
        e.preventDefault()
        if (isRequestSent) return

        onSubmit && onSubmit(email)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    if (isRequestSent) {
        return (
            <form className={`${className}`} onSubmit={handleSubmit}>
                <Title level={3}>Richiesta di recupero inviata</Title>
                <Paragraph style={{ textAlign: "center" }}>
                    Riceverai una mail contenente il link per il recupero della
                    password.
                </Paragraph>
            </form>
        )
    }

    return (
        <form className={`${className}`} onSubmit={handleSubmit}>
            <div className="form-item">
                <Title level={3}>Recupera la tua password</Title>
                {Error}
                <Row gutter={12}>
                    <Col span={24}>
                        <AppInput
                            label="E-mail"
                            value={email}
                            required={true}
                            onChange={(value) => {
                                setEmail(value)
                            }}
                        />
                    </Col>
                </Row>
            </div>
            <div className="form-item">
                <StyledAppButton className="primary" type="submit">
                    Conferma richiesta
                </StyledAppButton>
            </div>
        </form>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_ForgotPassword.propTypes = {
    className: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
    isRequestSent: PropTypes.bool,
    Error: PropTypes.func,
}

_ForgotPassword.defaultProps = {}

// ----------------------------------------------------------------------------

const ForgotPassword = styled(_ForgotPassword)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default ForgotPassword
